import { PropsWithChildren, createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { EXHUT_BIZ_SCAN_TO_ORDER_TABLE_CODE } from "../utils/constants";

export interface IAuthContext {
  tableCode: string | null;
}

const AuthContext = createContext<IAuthContext>({
  tableCode: null,
});

export const useAuthContext = () => useContext(AuthContext);

export default function AuthProvider(props: PropsWithChildren) {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const tableCode = queryParams.get("tab_code");

  useEffect(() => {
    if (tableCode) {
      localStorage.setItem(EXHUT_BIZ_SCAN_TO_ORDER_TABLE_CODE, tableCode);
      queryParams.delete("tab_code");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableCode]);

  return (
    <AuthContext.Provider value={{ tableCode }}>
      {props.children}
    </AuthContext.Provider>
  );
}
